export default "__VITE_ASSET__DiDhoL3___"